import { render } from "./SaveIcon.vue?vue&type=template&id=32d01b07"
import script from "./SaveIcon.vue?vue&type=script&lang=js"
export * from "./SaveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__